import { Redirect, Route, type RouteProps } from 'react-router-dom';
import { store } from 'src/store';
import NotFound from 'src/modules/Private/NotFound';
import { useEffect } from 'react';
import { Bugsnag } from "src/helpers/bugsnag"
import { type IUser } from 'src/models';

let state = store.getState();
store.subscribe(() => {
	state = store.getState();
});

interface Props {
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	component: any;
	rights?: string[];
	skipValidation?: boolean;
}

export const PrivateRoute = ({
	component: Component,
	rights,
	skipValidation,
	...rest
}: Props & RouteProps) => {
	const userData: IUser = state.auth.data;

	useEffect(() => {
		if (userData.id) {
			Bugsnag.setUser(
				userData.id,
				userData.email,
				userData.username
			)
		}
	}, [userData.id])

	if (!rights?.includes(userData.type || '') && !skipValidation) {
		return <Route component={NotFound} />;
	}

	return (
		<Route
			{...rest}
			render={(props) =>
				state.auth.isAuth ? (
					<Component {...props} />
				) : (
					<Redirect
						to={{
							pathname: '/login',
							state: { from: props.location },
						}}
					/>
				)
			}
		/>
	);
};
